import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bio", "toggle"]

  connect() {
    this.expanded = false
    // Hide the toggle if the text does not overflow the clamp height
    requestAnimationFrame(() => this.updateToggleVisibility())
  }

  toggle(event) {
    event.preventDefault()
    this.expanded = !this.expanded
    this.element.classList.toggle("is-expanded", this.expanded)
    this.toggleTarget.textContent = this.expanded ? "Thu gọn" : "Xem thêm"
    this.toggleTarget.setAttribute("aria-expanded", this.expanded ? "true" : "false")
  }

  updateToggleVisibility() {
    if (!this.hasBioTarget || !this.hasToggleTarget) return
    const needsToggle = this.bioTarget.scrollHeight - this.bioTarget.clientHeight > 2
    this.toggleTarget.hidden = !needsToggle
  }
}
